import { render } from "./myFamily.vue?vue&type=template&id=cd7082e6&scoped=true"
import script from "./myFamily.vue?vue&type=script&lang=js"
export * from "./myFamily.vue?vue&type=script&lang=js"

import "./myFamily.vue?vue&type=style&index=0&id=cd7082e6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd7082e6"]])

export default __exports__